import { render, staticRenderFns } from "./jdyjs.vue?vue&type=template&id=75452556&scoped=true&"
import script from "./jdyjs.vue?vue&type=script&lang=js&"
export * from "./jdyjs.vue?vue&type=script&lang=js&"
import style0 from "./jdyjs.vue?vue&type=style&index=0&id=75452556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75452556",
  null
  
)

export default component.exports